import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from 'js-cookie';
import { Box, Divider, Grid, Typography, useTheme, lighten, Alert } from "@mui/material";
import { isLoading, isSuccess, isFailed } from "../../../constants/redux.constants";
import { getProfileDevice, deleteProfileDevice, clearDeleteDeviceLS } from "../../../reducers/Profile";
import { showNotification } from "../../../reducers/App";
import { Card } from "../../ui";
import dayjs from "dayjs";
import { ProfileDeviceSkeleton } from "./skeletons";
import { getUrlParamEncoded } from "../utils/getUrlParamEncoded";



const deviceMap = {
  'ios':      'iPhone',
  'Android':  'Android',
  'web':      'Веб-браузер'
}

function DevicesList() {
  document.title = "Д24 | Устройства";
  const dispatch = useDispatch();
  const theme = useTheme();

  const { deviceList, deviceListLS, deleteDeviceLS } = useSelector(state => state.profile)

  const token = getUrlParamEncoded('token');
  const mobileToken = decodeURIComponent(token || '');
  // new URLSearchParams(window.location.search).get('token') || Cookies.get('token');

  useEffect(() => {
    dispatch(getProfileDevice())

    return () => {
      dispatch(clearDeleteDeviceLS())
    }
  }, [])


  const deleteDevice = async (token_id, access_token) => {
    if(!token_id) return;


    if(!isLoading(deleteDeviceLS)) {
      const result = await dispatch(deleteProfileDevice({ token_id, params: { flag_active: 'Н' }}));

      if(result.payload.ok) {
        dispatch(showNotification({ isOpen: true, message: 'Данные успешно обновлены', severity: 'success' }))

        if(access_token == mobileToken) {
          window.location.href = `https://auth.ds24.ru/?logout&message=${encodeURIComponent('Вы вышли из своего мобильного устройства. Пожалуйста, зайдите с нового.')}`

          return;
        }

        dispatch(getProfileDevice());
      }
    }
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ pl: { xs: 0.5, md: 0, display: token ? 'none' : 'inline-flex' } }} pb={3}>Устройства</Typography>
      {isLoading(deviceListLS) && <ProfileDeviceSkeleton />}

      {isFailed(deviceListLS) && (
        <Box minWidth={'100%'}>
          <Alert sx={{ p: 2.5 }} severity='error'>Произошла ошибка. Обновите страницу</Alert>
        </Box>
      )}

      {isSuccess(deviceListLS) && !deviceList.length && (
        <Box minWidth={'100%'}>
          <Alert sx={{ p: 2.5 }} severity='warning'>Нет привязанных устройств.</Alert>
        </Box>
      )}

      {isSuccess(deviceListLS) && deviceList.length > 0 && (
        <>
        <Grid container xs={12} md={8} gap={{ xs: 1, md: 2 }}>
          <Card sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minWidth: '100%', 
            border: `1px solid ${theme.palette.OICO.stone[200]}`,
            p: { xs: 2, md: 3 },
            mb: { xs: 1, md: 2 },
            gap: 1
            }}
          >
            {deviceList.map((device, index) => (
              <Box key={device.token_id}>
                <Grid container 
                  sx={{ 
                    flexDirection: { xs: 'column', md: 'row' }, 
                    justifyContent: { xs: 'start', md: 'space-between' }, 
                    alignItems: { xs: 'start', md: 'center' }
                  }}>
                  <Grid item>
                    <Typography sx={{ fontSize: 14, fontWeight: 500, display: 'flex', gap: 0.5 }}>
                      {deviceMap[device.dev_type] || 'Неизвествно'}
                      {device.access_token == mobileToken && (
                        <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>(это устройство)</Typography>
                      )}
                    </Typography>
                    <Typography sx={{ fontSize: 14, color: theme.palette.grey.main }}>
                      Дата регистрации: {dayjs(device.created_on_tz).format('DD.MM.YYYY, HH:mm')}
                    </Typography>
                  </Grid>

                  {device.dev_type !== 'web' && (
                    <Typography 
                      sx={{ 
                        position: 'relative',
                        pt: { xs: 1.5, md: 0 },
                        fontSize: 14, 
                        transition: 'all 0.3s ease', 
                        color: isLoading(deleteDeviceLS) 
                          ? theme.palette.OICO.neutral[400] 
                          : theme.palette.text.link,
                        '&:hover': {
                          color: isLoading(deleteDeviceLS) 
                            ? theme.palette.OICO.neutral[400]
                            : lighten(theme.palette.OICO.blue, 0.1)
                        },
                        cursor: isLoading(deleteDeviceLS) ? 'default' : 'pointer',
                        pointerEvents: isLoading(deleteDeviceLS) ? 'none' : 'auto'
                      }}
                      onClick={!isLoading(deleteDeviceLS) ? () => deleteDevice(device.token_id, device.access_token) : undefined}
                    >
                      Завершить сеанс
                    </Typography>
                  )}
                </Grid>
                {index !== deviceList.length - 1 && (
                  <Divider sx={{ bgcolor: theme.palette.OICO.neutral[300], my: { xs: 1.5, md: 2 } }} />    
                )}
              </Box>
            ))}
          </Card>
        </Grid>
        </>
      )}
    </Box>
  )
}

export default DevicesList;